module.exports = __webpack_public_path__ + "static/media/slide4.e8cd5d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide4.jpg
// module id = 840
// module chunks = 0